<template>
    <div v-if="hotRankList.length !== 0" class="pc-ranklist">
        <div class="pc-ranklist-head">
            <div :class="rankindex === 1 ? 'active' : '' " @click="getrank(1)">热销榜</div>/
            <div :class="rankindex === 2 ? 'active' : '' " @click="getrank(2)">史低榜</div>/
            <div :class="rankindex === 3 ? 'active' : '' " @click="getrank(3)">好评榜</div>
        </div>
        <div class="pc-rank scroll-x">
            <div
                v-for="(item, index) of hotRankList"
                v-show="rankindex === 1 "
                :key="'A' + index"
                class="pc-hotsale-item over-ellipsis"
                @click="jumpDetail(item)"
            >
                <div class="pc-rank-content">
                    <img
                        class="item-img"
                        :src="item.game_icon"
                        alt=""
                    >
                    <div class="item-rank-num">
                        <img
                            v-if="index < 3"
                            class="item-rank-num"
                            :src="rankPic[index]"
                            alt=""
                        >
                        <p
                            v-else
                            class="item-rank-num-else"
                            :style="'background-image:url(' + rankPic[3] + ')'"
                        >{{ index + 1 }}</p>
                    </div>
                    <div v-if="item.price_trend_text" class="item-buy-num">
                        <span class="item-buy-content">{{ item.price_trend_text }}</span>
                    </div>
                </div>
                <div class="item-appName">{{ item.game_name }}</div>
                <div class="item-sale-num">
                    <div
                        class="item-sale-num-left"
                        :style="!!item.is_lowest_price ? 'border-radius: 2px 0 0 2px;' : 'border-radius: 2px;'"
                    >
                        -¥{{ item.discount_amount | decimal(2, 0.01) }}
                    </div>
                    <div v-if="!!item.is_lowest_price" class="item-sale-num-right">
                        史低
                    </div>
                </div>
                <div class="item-price">
                    <div class="item-discount-price-icon">
                        ￥
                    </div>
                    <div class="item-discount-price">
                        {{ item.discount_price | decimal(2, 0.01) }}
                    </div>
                    <div class="item-original-price">
                        <div>¥{{ item.original_price | decimal(2, 0.01) }}</div>
                    </div>
                </div>
            </div>
            <div
                v-for="(item, index) of lowestRankList" v-show="rankindex === 2 "
                :key="'B' + index" class="pc-hotsale-item over-ellipsis"
                @click="jumpDetail(item)"
            >
                <div class="pc-rank-content">
                    <img
                        class="item-img"
                        :src="item.game_icon"
                        alt=""
                    >
                    <div class="item-rank-num">
                        <img
                            v-if="index < 3"
                            class="item-rank-num"
                            :src="rankPic[index]"
                            alt=""
                        >
                        <p
                            v-else
                            class="item-rank-num-else"
                            :style="'background-image:url(' + rankPic[3] + ')'"
                        >{{ index + 1 }}</p>
                    </div>
                    <div v-if="item.price_trend_text" class="item-buy-num">
                        <span class="item-buy-content">{{ item.price_trend_text }}</span>
                    </div>
                </div>
                <div class="item-appName">{{ item.game_name }}</div>
                <div class="item-sale-num">
                    <div
                        class="item-sale-num-left"
                        :style="!!item.is_lowest_price ? 'border-radius: 2px 0 0 2px;' : 'border-radius: 2px;'"
                    >
                        -¥{{ item.discount_amount | decimal(2, 0.01) }}
                    </div>
                    <div v-if="!!item.is_lowest_price" class="item-sale-num-right">
                        史低
                    </div>
                </div>
                <div class="item-price">
                    <div class="item-discount-price-icon">
                        ￥
                    </div>
                    <div class="item-discount-price">
                        {{ item.discount_price | decimal(2, 0.01) }}
                    </div>
                    <div class="item-original-price">
                        <div>¥{{ item.original_price | decimal(2, 0.01) }}</div>
                    </div>
                </div>
            </div>
            <div
                v-for="(item, index) of goodsRankList" v-show="rankindex === 3 "
                :key="'C' + index" class="pc-hotsale-item over-ellipsis"
                @click="jumpDetail(item)"
            >
                <div class="pc-rank-content">
                    <img
                        class="item-img"
                        :src="item.game_icon"
                        alt=""
                    >
                    <div class="item-rank-num">
                        <img
                            v-if="index < 3"
                            class="item-rank-num"
                            :src="rankPic[index]"
                            alt=""
                        >
                        <p
                            v-else
                            class="item-rank-num-else"
                            :style="'background-image:url(' + rankPic[3] + ')'"
                        >{{ index + 1 }}</p>
                    </div>
                    <div v-if="item.price_trend_text" class="item-buy-num">
                        <span class="item-buy-content">{{ item.price_trend_text }}</span>
                    </div>
                </div>
                <div class="item-appName">{{ item.game_name }}</div>
                <div class="item-sale-num">
                    <div
                        class="item-sale-num-left"
                        :style="!!item.is_lowest_price ? 'border-radius: 2px 0 0 2px;' : 'border-radius: 2px;'"
                    >
                        -¥{{ item.discount_amount | decimal(2, 0.01) }}
                    </div>
                    <div v-if="!!item.is_lowest_price" class="item-sale-num-right">
                        史低
                    </div>
                </div>
                <div class="item-price">
                    <div class="item-discount-price-icon">
                        ￥
                    </div>
                    <div class="item-discount-price">
                        {{ item.discount_price | decimal(2, 0.01) }}
                    </div>
                    <div class="item-original-price">
                        <div>
                            ¥{{ item.original_price | decimal(2, 0.01) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import num_1 from 'public/assets/imgs/num1.png';
import num_2 from 'public/assets/imgs/num2.png';
import num_3 from 'public/assets/imgs/num3.png';
import num_4 from 'public/assets/imgs/tag4.png';
import api from '@/api';
import {getQueryString} from '@/utils/url';

export default {
    components: {
    },
    data() {
        return {
            rankPic: [num_1, num_2, num_3, num_4],
            rankindex: 1,
            hotRankList: [],
            goodsRankList: [],
            lowestRankList: [],
            srcid: getQueryString('srcid'),
            channelid: getQueryString('channelid') || getQueryString('idfrom'),
        };
    },
    created() {
        api.zone.getSaleRank().then(res => {
            this.hotRankList = res.data.hot;
            this.goodsRankList = res.data.good;
            this.lowestRankList = res.data.lowest;
        });
    },
    methods: {
        getrank(type) {
            if (type === 1) {
                this.rankindex = 1;
            }
            else if (type === 2) {
                this.rankindex = 2;
            }
            else if (type === 3) {
                this.rankindex = 3;
            }
        },
        jumpDetail(item) {
            window.location.href = `http://gamecenter.baidu.com/static/game/zone.html?srcid=${this.srcid}&appId=${item.game_id}&channelid=${this.channelid}&query=${item.game_name}&sid=#`;
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/common/style/mixin/utils";
@import "~@/common/style/mixin/mixins";

.pc-ranklist {
     margin-left: 51px;
    .pc-ranklist-head {
        display: flex;
        height: 60px;
        font-family: PingFangSC-Regular;
        font-size: 51px;
        color: #B3B3B3;
        line-height: 60px;
        font-weight: 400;
        margin-bottom: 52px;
    }
    .pc-rank {
        display: flex;
        flex-shrink: 0;
        .pc-hotsale-item {
            margin-right: 66px;
            .pc-rank-content {
                position: relative;
                 .item-img {
                    display: block;
                    width: 267px;
                    height: 356px;
                    border-radius: 27px;
                }
                .item-rank-num {
                    width: 61px;
                    height: 64px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .item-rank-num-else {
                    background-size: 100% 100%;
                    width: 61px;
                    height: 64px;
                    position: absolute;
                    top: -42px;
                    left: 0;
                    text-align:center;
                    color: #3388FF;
                    line-height:64px;
                    text-align: center;
                    font-size: 42px;
                    font-weight: 600;
                    font-family: PingFangSC-Semibold;
                }
                .item-buy-num {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 267px;
                    text-align: right;
                    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #333 100%);
                    padding-bottom: 21px;
                    border-radius: 27px;
                    .item-buy-content {
                        width: 146px;
                        height: 33px;
                        font-family: PingFangSC-Regular;
                        font-size: 33px;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        line-height: 33px;
                        font-weight: 400;
                        margin-right: 18px;
                    }
                }
            }
            .item-appName {
                margin: 17px 0;
                text-align: left;
                font-size: 48px;
                width: 300px;
                color: #1F1F1F;
                letter-spacing: 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .item-sale-num {
                display: flex;
                .item-sale-num-left {
                    font-family: PingFangSC-Regular;
                    box-sizing: border-box;
                    color: #333333;
                    padding: 12px 12px;
                    font-size: 36px;
                    font-weight: 400;
                    height: 56px;
                    line-height: 36px;
                    background: rgba(0,0,0,0.05);
                    text-align: center;
                }
                .item-sale-num-right {
                    width: 90px;
                    height: 56px;
                    box-sizing: border-box;
                    font-size: 36px;
                    background: #333333;
                    border-radius: 0px 2px 2px 0px;
                    text-align: center;
                    color: #fff;
                    padding: 1px 1px;
                }

            }
            .item-price {
                display: flex;
                margin-top: 29px;
                justify-content:flex-start;
                align-items: center;
                .item-discount-price-icon {
                    height: 48px;
                    font-family: PingFangSC-Semibold;
                    font-size: 48px;
                    color: #F14027;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 600;
                }
                .item-discount-price {
                    height: 48px;
                    font-family: PingFangSC-Semibold;
                    font-size: 48px;
                    color: #F14027;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 600;
                    margin-right: 12px;
                }
                .item-original-price {
                    height: 48px;
                    font-family: PingFangSC-Regular;
                    font-size: 33px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 48px;
                    text-decoration: line-through;
                    font-weight: 400;
                    position: relative;
                }
            }
        }
    }
    .active {
        height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 57px;
        color: #000000;
        line-height: 60px;
        font-weight: 500;
    }
}
</style>